module.exports = __webpack_public_path__ + "img/ai.ai8eb1e0e.svg";